export const getOptions = (storeState: any) => storeState.options;
